<template>
    <v-dialog v-model="modal" width="800">
        <v-card>
            <v-card-title>Gênero</v-card-title>
            <v-card-text>
                <v-text-field
                    label="Nome"
                    v-model="gender.name"
                ></v-text-field>
            </v-card-text>
            <v-card-actions>
                <v-btn color="error" @click="fecharModal">Cancelar</v-btn>
                <v-btn color="success" @click="salvar" :loading="loading">Salvar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import GenderService from '@/server/GenderService';


export default {
    name:"ModalGender",
    props:{
        list:{
            type:Function
        }
    },
    data:() =>({
        modal:false,
        service: new GenderService(),
        loading:false
    }),
    computed:{
        gender:{
            get(){return this.$store.getters['getGender']},
            set(dado){this.$store.dispatch('setGender', dado)}
        }
    },
    methods:{
        abrirModal(){
            this.modal = true;
        },
        fecharModal(){
            this.modal = false;
            this.gender = null;
        },
        salvar(){
            this.loading = true;
            if(this.gender.id){
                this.service.edit(this.gender)
                    .then(() => {
                        this.list()
                        this.fecharModal()
                        this.loading = false;
                    })
            }else{
                this.service.create(this.gender)
                    .then(() => {
                       this.list() 
                       this.fecharModal()
                        this.loading = false;
                    })
            }
        },
    }
}
</script>